import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import synchronize from './submodules/synchronize-destock';

const state = {
    establishment: null,
    stock: null,
    establishment_stocks: [],
    establishment_stocks_loading: false,
    destock_components_if_needed: false,
};

const mutations = {
    updateEstablishment(state, establishment) {
        state.establishment = establishment;
        state.stock = null; // Reset stock when establishment changes
    },
    updateStock(state, stock) {
        state.stock = stock;
    },
    updateEstablishmentStocks(state, stocks) {
        state.establishment_stocks = stocks;
        state.establishment_stocks_loading = false;
    },
    updateEstablishmentStocksLoading(state, loading) {
        state.establishment_stocks_loading = loading;
    },
    updateDestockComponentsIfNeeded(state, value) {
        state.destock_components_if_needed = value;
    },
};

const actions = {
    async init({ commit, dispatch, state }, params) {
        await dispatch("synchronize/init", { extra_params: {} });
    },

    changeEstablishment({ commit, dispatch, state }, establishment) {
        commit("updateEstablishment", establishment);
        commit("updateStock", null);
        if (establishment) {
            dispatch("fetchEstablishmentStocks", establishment);
        } else {
            commit("updateEstablishmentStocks", []);
        }
    },

    changeStock({ commit }, stock) {
        commit("updateStock", stock);
    },

    async fetchEstablishmentStocks({ commit }, establishment) {
        commit("updateEstablishmentStocksLoading", true);
        try {
            // Fetch all stocks for the establishment (with pagination)
            let allStocks = [];
            let url = '/api/stocks/';
            let params = {
                establishment: establishment,
                archived: false,
                track_stock: true,
                limit: 100, // Fetch up to 100 stocks per page
            };
            
            // First request
            let response = await axios.get(url, { params });
            if (response.data.results) {
                allStocks = allStocks.concat(response.data.results);
            }
            
            // Continue fetching if there's a next page
            let nextUrl = response.data.next;
            while (nextUrl) {
                // For subsequent requests, use the full URL which already contains params
                response = await axios.get(nextUrl);
                if (response.data.results) {
                    allStocks = allStocks.concat(response.data.results);
                }
                nextUrl = response.data.next || null;
            }
            
            commit("updateEstablishmentStocks", allStocks);
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateEstablishmentStocks", []);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        synchronize: synchronize(),
    }
};

